import { AlertCircle, CheckCircle2, Info } from "lucide-react";
import { cn } from "@/lib/utils";

type FeedbackTone = "error" | "success" | "info";

const toneClass: Record<FeedbackTone, string> = {
  error: "border-red-200 bg-red-50 text-red-700",
  success: "border-green-200 bg-green-50 text-green-700",
  info: "border-brand-200 bg-brand-50 text-brand-700",
};

const icon = {
  error: AlertCircle,
  success: CheckCircle2,
  info: Info,
};

export function FeedbackMessage({
  tone,
  children,
  className,
}: {
  tone: FeedbackTone;
  children: React.ReactNode;
  className?: string;
}) {
  const Icon = icon[tone];
  if (!children) return null;

  return (
    <p className={cn("flex items-start gap-2 rounded-md border px-3 py-2 text-sm", toneClass[tone], className)}>
      <Icon className="mt-0.5 h-4 w-4 shrink-0" />
      <span className="min-w-0 break-words">{children}</span>
    </p>
  );
}

export function Skeleton({ className = "" }: { className?: string }) {
  return <div className={cn("animate-pulse rounded-md bg-brand-100", className)} aria-hidden="true" />;
}

export function CardSkeleton({ rows = 3 }: { rows?: number }) {
  return (
    <div className="rounded-xl border border-brand-100 bg-white p-4 shadow-sm" aria-label="Loading content">
      <Skeleton className="h-5 w-1/2" />
      <div className="mt-4 grid gap-2">
        {Array.from({ length: rows }).map((_, index) => (
          <Skeleton key={index} className={index === rows - 1 ? "h-4 w-2/3" : "h-4 w-full"} />
        ))}
      </div>
    </div>
  );
}
